export default __webpack_public_path__ + "static/media/Transfer.2fd5c703.svg";